import { APP_LOGGING_API_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";

import AppLoggingApiMaster from "./AppLoggingApiMaster/AppLoggingApiMaster";

function AppLoggingApiView() {
  // const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={APP_LOGGING_API_MASTER_ROUTE}
        key={APP_LOGGING_API_MASTER_ROUTE}
        component={AppLoggingApiMaster}
        auth={true}
      />
    </Switch>
  );
}

export { AppLoggingApiMaster };
export default AppLoggingApiView;
